import Vue from 'vue';
import assignWith from 'lodash/assignWith';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
Vue.config.optionMergeStrategies.methods = (mixin: any, component: any) => {
  return assignWith({}, mixin, component, (objValue, srcValue) => {
    if (srcValue && srcValue.overrideOthers) {
      return srcValue;
    } else if (objValue && objValue.overrideOthers) {
      return objValue;
    }
  });
};
